import Config from "src/app.config";

const BASE_URL = Config.INTERNAL_GATEWAY_URL;

const CLIENT_IDS = {
  giftCards: "ddc41bdc-9e3b-4b43-ac0e-e883c92b7122",
  discounts: "82412eab-136a-4cdf-816a-0cc23447fa28",
};

const isClient = (request: Request, clientId: string) => request.headers.get("clientid") === clientId;

export { BASE_URL, CLIENT_IDS, isClient };
